<template>
  <div class="video-player-container">
    <div ref="videoPlayerWrap" class="video-player-wrap">
      <div class="video-player-box" @click.stop="onVideoClick" :class="showComment && 'small'">
        <!-- <video
          ref="videoPalyer"
          :data-id="videoObj.id"
          :id="`video-player-${videoObj.id}`"
          class="video-player"
          @touchend="onVideoClick"
          :nativeControls="false"
          :style="{ backgroundImage: `url('${videoObj.coverimg}')`}"
          preload
          loop
          :style="{
            backgroundImage: `url('${videoObj.coverimg}?x-oss-process=image/resize,w_750/auto-orient,1')`
          }"
          :src="videoObj.videourl"
        ></video> -->
        <!-- @click.stop.prevent="onVideoClick" -->
        <video
          ref="videoPalyer"
          class="video-player"
          muted
          x5-muted
          webkit-muted
          autoplay
          x5-autoplay
          webkit-autoplay
          preload="auto"
          x5-playsinline
          webkit-playsinline
          playsinline
          loop
          x5-loop
          webkit-loop
          @playing="handlePlaying"
          :poster="`url('${videoObj.coverimg}?x-oss-process=image/resize,w_750/auto-orient,1')`"
          @timeupdate="handleTimeUpdate()"
          :style="{
            objectFit: showComment ? 'scale-down' : 'contain'
          }"
          :src="videoObj.videourl"
        ></video>
      </div>
      <template>
        <div v-show="showComment" class="comment-wrap" :class="showComment && 'active'">
          <div class="header">
            <span class="close-btn"></span>
            <span class="center">
              {{ videoObj.commentnum > 0 ? videoObj.commentnum + '条' : '评论列表' }}
            </span>
            <img
              class="close-btn"
              src="/static/images/beautitysaid/close.png"
              @click.stop="hideShowCommnet(false)"
            />
          </div>
          <!-- @touchend.stop="openSelect({ item: item, index: index })" -->
          <div class="comment_list" v-if="commentlist">
            <Scroller
              :is-refresh-data.sync="refresh"
              :is-loading-data.sync="loading"
              :is-finished-data.sync="finished"
              :is-disabled-data="disabled"
              @on-infinite="onInfinite"
            >
              <div class="list" v-if="commentlist && commentlist.length > 0">
                <div class="pro_comment_item" v-for="(item, index) of commentlist" :key="index">
                  <div class="pro_comment_item_box">
                    <div>
                      <div class="comment_head_info">
                        <div class="img">
                          <head-pendant :identity="item.identity">
                            <img
                              v-if="item.comment_head"
                              :src="item.comment_head"
                              @error="
                                (event) => {
                                  let img = event.srcElement
                                  img.src = errorHeadImg
                                  img.onerror = null
                                }
                              "
                            />
                            <img v-if="!item.comment_head" :src="errorHeadImg" />
                          </head-pendant>
                        </div>
                        <div class="info">
                          <div class="namebox">
                            <div class="name flex-ac">
                              <p class="over-ell-1">{{ item.comment_name }}</p>
                              <img
                                v-if="item.authorlevel && item.authorlevel != 0"
                                :src="$getVipLevel(item.authorlevel)"
                              />
                            </div>
                            <div class="time" v-if="item.isauthor">作者</div>
                          </div>
                          <div
                            @click.stop="commentFn({ item: item, index: index })"
                            class="comment_content_info"
                          >
                            <div class="comment_txt" :class="{ delete: item.isdeleted == 1 }">
                              {{ item.isdeleted != 1 ? item.comment : '该内容已删除' }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="comment_content_info"
                        @click.stop="commentFn({ item: item, index: index })"
                      >
                        <div class="comment_txt name time" style="padding-left: 0.3rem;">
                          {{ item.comment_time }}
                        </div>
                        <div class="comment_txt name time reply_btn">
                          回复
                        </div>
                      </div>
                    </div>
                    <div
                      class="love"
                      v-if="item.isdeleted != 1"
                      @click.stop="onPraise({ item: item, index: index })"
                    >
                      <img
                        :src="
                          item.ispraise == 0
                            ? '/static/images/community/notlike.png'
                            : '/static/images/community/like.png'
                        "
                      />
                      <p>{{ item.praisenum }}</p>
                    </div>
                  </div>
                  <!-- openSelect({ item: item, index: index, itemSon: itemSon, indexSon: indexSon }) -->
                  <div
                    class="pro_comment_item pro_comment_item_box comment_reply_item"
                    v-if="item.isdeleted != 1"
                    v-for="(itemSon, indexSon) of item.comment_reply"
                    :key="indexSon"
                    @click.stop=""
                  >
                    <div>
                      <div class="comment_head_info">
                        <div class="img">
                          <head-pendant :identity="itemSon.identity">
                            <img
                              v-if="itemSon.reply_head"
                              :src="itemSon.reply_head"
                              @error="
                                (event) => {
                                  let img = event.srcElement
                                  img.src = errorHeadImg
                                  img.onerror = null
                                }
                              "
                            />
                            <img v-if="!itemSon.reply_head" :src="errorHeadImg" />
                          </head-pendant>
                        </div>
                        <div class="info">
                          <div class="namebox">
                            <div class="name flex-ac">
                              <div class="over-ell-1">
                                {{ itemSon.reply_name }}
                              </div>
                              <img
                                v-if="itemSon.authorlevel && itemSon.authorlevel != 0"
                                :src="$getVipLevel(itemSon.authorlevel)"
                              />
                              <div v-if="itemSon.reply_to_name" class="sj"></div>
                              <div class="over-ell-1">{{ itemSon.reply_to_name }}</div>
                            </div>
                            <div class="time" v-if="itemSon.isauthor">作者</div>
                          </div>
                          <div
                            @click.stop="
                              commentFn({
                                item: item,
                                index: index,
                                itemSon: itemSon,
                                indexSon: indexSon
                              })
                            "
                            class="comment_content_info"
                          >
                            <div class="comment_txt">
                              {{ itemSon.reply }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="comment_content_info"
                        @click.stop="
                          commentFn({
                            item: item,
                            index: index,
                            itemSon: itemSon,
                            indexSon: indexSon
                          })
                        "
                      >
                        <div class="comment_txt name time" style="padding-left: 0.2rem;">
                          {{ itemSon.reply_time }}
                        </div>
                        <div class="comment_txt name time reply_btn">
                          回复
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="more"
                    v-if="
                      item.comment_reply.length > 0 &&
                        item.comment_reply.length % 5 == 0 &&
                        item.ismorereply
                    "
                    @click.stop="more({ item: item, index: index })"
                  >
                    展开更多回复
                  </div>
                  <div
                    class="more"
                    v-if="item.comment_reply.length > 5 && item.comment_reply.length % 5 != 0"
                    @click.stop="putItAway({ item: item, index: index })"
                  >
                    收起
                  </div>
                </div>
              </div>
            </Scroller>
            <div v-if="finished && !commentlist.length" class="empty-comment">
              <img src="/static/images/beautitysaid/empty_comment.png" alt="" srcset="" />
              <span>期待你的评论</span>
              <span>发表评论参与评论～</span>
            </div>
          </div>
        </div>
        <div v-show="showComment" class="comment-box">
          <van-field
            ref="commentRef"
            class="comment-ipt"
            @blur="onBlur"
            v-model="msgValue"
            label=""
            :placeholder="placeholder"
          />
          <span class="send-btn" :class="msgValue && 'can-send'" @click.stop="submitComment">
            发送
          </span>
        </div>
        <div v-show="pausedStatus" @click="onVideoClick" id="playIcon" class="play-icon">
          <van-icon size="100px" color="#ffffff" name="play-circle-o" />
        </div>
        <div class="tool-bar">
          <div class="avatur-box">
            <img @click.stop="goCommunity" :src="videoObj.authorhead" alt="" srcset="" />
            <img
              @click.stop="onFollow"
              v-if="videoObj.isfollow == 0"
              class="floow-icon"
              src="/static/images/beautitysaid/floow_icon.png"
              alt=""
              srcset=""
            />
          </div>
          <div class="info-item" @click.stop.prevent="onPraise">
            <van-icon
              size="28px"
              color="#ffffff"
              :name="
                videoObj.ispraise
                  ? '/static/images/community/like.png'
                  : '/static/images/beautitysaid/parse_icon.png'
              "
            />
            <span class="f14">{{ videoObj.praisenum > 999 ? '999+' : videoObj.praisenum }}</span>
          </div>
          <div class="info-item" @click.stop="hideShowCommnet(true)">
            <van-icon
              size="28px"
              color="#ffffff"
              name="/static/images/beautitysaid/message_icon.png"
            />
            <span class="f14">{{ videoObj.commentnum > 999 ? '999+' : videoObj.commentnum }}</span>
          </div>
          <div class="info-item" @click.stop="collectionFn()">
            <van-icon
              size="28px"
              color="#ffffff"
              :name="
                videoObj.iscollection == 0
                  ? '/static/images/beautitysaid/collect_icon.png'
                  : '/static/images/community/collection1.png'
              "
            />
            <span class="f14">
              {{ videoObj.collectionnum > 999 ? '999+' : videoObj.collectionnum }}
            </span>
          </div>
          <div class="info-item" @click.stop="onShare()">
            <van-icon
              size="28px"
              color="#ffffff"
              name="/static/images/beautitysaid/share_icon.png"
            />
            <span class="f14">{{ videoObj.sharenum > 0 ? videoObj.sharenum : '分享' }}</span>
          </div>
          <div class="info-item" @click.stop="onSearch">
            <van-icon
              size="28px"
              color="#ffffff"
              name="/static/images/beautitysaid/bottom_search.png"
            />
          </div>
        </div>
      </template>
      <div class="video-footer-box">
        <div
          v-if="videoObj.goods && videoObj.goods.length"
          class="event about-goods"
          @click.stop="onGoodsClick"
        >
          <img src="/static/images/beautitysaid/about_goods.png" alt="" srcset="" />
          <span>关联商品</span>
        </div>
        <div class="video-footer">
          <div v-if="!showMore" class="f14  desc" @click.stop="showMore = !showMore">
            {{ videoObj.title.length > 36 ? videoObj.title.substr(0, 36) + '...' : videoObj.title }}
            <span class="more-text" v-if="videoObj.title.length > 36">展开</span>
          </div>
          <div v-else class="f14 desc" @click.stop="showMore = !showMore">
            {{ videoObj.title }}
            <span class="more-text" v-if="videoObj.title.length > 36">收起</span>
          </div>
          <div class="home-img" @touchend.stop="goHome">
            <img src="/static/images/beautitysaid/logo.png" alt="" srcset="" />
          </div>
        </div>
      </div>

      <div class="progress-bar">
        <div v-if="coverPrgress" class="time-info">
          {{ convertSeconds($refs.videoPalyer.currentTime) }}/{{
            convertSeconds($refs.videoPalyer.duration)
          }}
        </div>
        <!-- @touchstart.stop.prevent="onBarTouchStart"
      @touchend.stop.prevent="onBarTouchend" -->
        <!-- <span class="cur-time">0:00</span> -->
        <van-slider
          @drag-start="onBarTouchStart"
          @drag-end="onBarTouchend"
          active-color="#ffffff"
          @input="onProgressChange"
          inactive-color="rgba(255,255,255,0.35)"
          v-model="value"
          :button-size="coverPrgress ? 40 : 12"
          :bar-height="coverPrgress ? 4 : 2"
        >
          <template #button>
            <div class="custom-button">
              <span class="dot"></span>
            </div>
          </template>
        </van-slider>
        <!-- <span class="all-time">120:00</span> -->
      </div>
    </div>
    <div class="footer"></div>
    <div v-if="initFail" class="model-view" @click="onVideoClick">
      <img src="/static/images/beautitysaid/hand.png" alt="" />
      <div class="tips-msg">点击观看</div>
    </div>
    <van-overlay :show="showshare" v-if="showshare" z-index="9999">
      <div class="sharecontainer sharefriend" v-if="showshare">
        <img src="/static/wx/img/sharebg2.png" />
        <van-button round plain type="danger" class="know" @click="hideShare">
          我知道了
        </van-button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import zymedia from '@/assets/js/zy.media'
import HeadPendant from '@/components/common/headPendant'
import Scroller from '@/components/common/Scroller'
import { Slider } from 'vant'
import {
  fenxiang,
  isApp,
  basepath,
  isWeixin,
  throttle,
  Base64,
  wxAjaxData,
  exclusiveidFn,
  pointParams,
  browHistory
} from '@/assets/common/js/config'
import wx from 'weixin-js-sdk'
const base = new Base64()
export default {
  props: {
    videoObj: Object
  },
  components: {
    HeadPendant,
    Scroller,
    [Slider.name]: Slider
  },
  data() {
    return {
      coverPrgress: false,
      pausedStatus: false,
      showComment: false,
      commentlist: [],
      msgValue: '', // 评论内容
      commentParams: {
        pagesize: 5,
        pageno: 1,
        itemid: this.videoObj.id
      },
      refresh: false,
      finished: false,
      disabled: true,
      loading: false,
      placeholder: '留下你的精彩留言',
      value: 0,
      initFail: false,
      isFirstVideo: true,
      showMore: false,
      replyloading: true,
      showshare: false,
      showTime: false
    }
  },
  mounted: () => {
    // zymedia(`.video-player`, {
    //   preload: 'auto',
    //   enableVisibilityState: false,
    //   alwaysShowNativeControls: false
    // })
  },
  created() {
    this.handleTimeUpdate = throttle(this.onTimeUpdate, 500).bind(this)
  },
  methods: {
    onVideoClick() {
      this.initFail = false
      console.log('this.$refs.videoPalyer.paused', this.$refs.videoPalyer.play)
      if (this.$refs.videoPalyer.paused) {
        this.$refs.videoPalyer.play().catch((err) => {
          console.log('点击播放视频失败')
          this.pausedStatus = this.$refs.videoPalyer.paused
        })
        this.pausedStatus = false
        this.hideShowCommnet(false)
      } else {
        this.$refs.videoPalyer.pause()
        this.pausedStatus = true
      }
    },
    reset() {
      this.commentParams.pageno = 1
      this.commentParams.itemid = this.videoObj.id
      this.replyloading = true
      this.commentlist = []
      this.finished = false
    },
    onBarTouchStart() {
      this.coverPrgress = true
      this.$emit('cantouch', true)
    },
    // 拖动进度条
    onBarTouchend() {
      this.coverPrgress = false
      this.$emit('cantouch', false)
    },
    onProgressChange() {
      if (this.$refs.videoPalyer && this.$refs.videoPalyer.currentTime) {
        this.$refs.videoPalyer.currentTime = (this.$refs.videoPalyer.duration * this.value) / 100
      }
    },
    convertSeconds(seconds) {
      var minutes = Math.floor(seconds / 60)
      var remainingSeconds = Math.ceil(seconds % 60)
      const obj = {
        minutes: minutes < 10 ? '0' + minutes : minutes,
        seconds: remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds
      }
      return obj.minutes + ':' + obj.seconds
    },
    // 评论显示隐藏
    hideShowCommnet(bol) {
      this.showComment = bol
      this.$emit('cantouch', bol)
      if (bol && !this.commentlist.length) {
        this.getLeaveData()
      }
    },
    handlePlaying() {
      this.initFail = false
      this.pausedStatus = false
      this.$refs.videoPalyer.muted = false
    },
    // 显示进度条
    showControl() {
      this.$clickburiedPoint({
        data: {
          beautityitemid: this.videoObj.id
        },
        url: 'community/userbehavior/save'
      })
      this.$customRequestAjax.get(this.$ajax.addPlayCount_URL, {
        params: {
          itemid: this.videoObj.id
        }
      })
      this.initShare()
      this.reset()
      this.pausedStatus = false
      this.showMore = false
      setTimeout(() => {
        if (this.$refs.videoPalyer && this.$refs.videoPalyer.paused) {
          this.$refs.videoPalyer
            .play()
            .then((err) => {
              this.$refs.videoPalyer.muted = false
              this.isFirstVideo = false
            })
            .catch((err) => {
              console.log('播放视频失败')
              this.$refs.videoPalyer.muted = false
              if (this.isFirstVideo) {
                this.$emit('cantouch', true)
                this.initFail = this.$refs.videoPalyer.paused
              } else {
                this.pausedStatus = this.$refs.videoPalyer.paused
              }
              this.isFirstVideo = false
            })
        }
      }, 500)
    },
    commentFn: function(obj) {
      this.commentObj = obj
      this.$refs.commentRef.focus()
      setTimeout(() => {
        if (obj.item.isdeleted != 1) {
          this.placeholder = obj.itemSon
            ? '回复' + obj.itemSon.reply_name
            : obj.item
            ? '回复' + obj.item.comment_name
            : '说点什么…'
        }
      }, 50)
    },
    onBlur() {
      console.log('this.msgValue.trim()', this.msgValue.trim())
      if (this.msgValue.trim() == '') {
        this.commentObj = null
        this.placeholder = '留下你的精彩留言'
      }
    },
    more: function(obj) {
      if (!this.replyloading) return
      this.replyloading = false
      var url =
        this.$ajax.getReplyMoreList +
        '?pageno=' +
        parseInt(obj.item.reply_nowpage) +
        '&pagesize=' +
        5 +
        '&commentid=' +
        obj.item.commentid
      obj.item.reply_nowpage = parseInt(obj.item.reply_nowpage) + 1
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code == 200) {
          this.replyloading = true
          if (res.data.data.comment_reply.length > 0) {
            obj.item.comment_reply = obj.item.comment_reply.concat(res.data.data.comment_reply)
            obj.item.ismorereply = true
          } else {
            obj.item.ismorereply = false
          }
        }
      })
    },
    onFollow() {
      var url = this.$ajax.follow_URL
      var paramsData = {
        isfollow: this.videoObj.isfollow == 0 ? 1 : 0
      }
      this.$customRequestAjax.post(url, paramsData).then((res) => {
        if (res.data.code === 200) {
          this.videoObj.isfollow = this.videoObj.isfollow == 0 ? 1 : 0
        }
      })
    },
    putItAway: function(obj) {
      obj.item.reply_nowpage = 2
      obj.item.comment_reply = obj.item.comment_reply.slice(0, 5)
      obj.item.ismorereply = true
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      this.commentParams.pageno = this.commentParams.pageno + 1
      this.getLeaveData()
    },
    // 获取评论列表
    getLeaveData: function() {
      var url = this.$ajax.getCommentList_BeautyTheory_URL
      this.$customRequestAjax
        .get(url, {
          params: this.commentParams
        })
        .then((res) => {
          if (res.data.code === 200) {
            res.data.data.commentlist.map((item) => {
              item.reply_nowpage = 2
              if (item.comment_reply.length >= this.commentParams.pagesize) {
                item.ismorereply = true
              } else {
                item.ismorereply = false
              }
            })
            if (this.commentParams.pageno === 1) {
              this.commentlist = res.data.data.commentlist
              this.refresh = false
            } else {
              this.commentlist = this.commentlist.concat(res.data.data.commentlist)
            }
            this.loading = false
            if (res.data.data.commentlist.length < this.commentParams.pagesize) {
              this.finished = true
            } else {
              this.finished = false
            }
          }
        })
    },

    submitComment() {
      if (this.msgValue == '') {
        return
      }
      this.$ckeckgraphic({
        content: this.msgValue,
        callback: () => {
          var url = this.$ajax.addVideoComment_URL
          var data = {
            itemid: this.videoObj.id,
            comment: this.msgValue.trim()
          }
          console.log('this.commentObj', this.commentObj)
          if (this.commentObj) {
            if (this.commentObj.itemSon) {
              url = this.$ajax.addReply_URL
              data = {
                replyid: this.commentObj.itemSon.replyid,
                replycontent: this.msgValue.trim()
              }
            } else if (this.commentObj.item) {
              url = this.$ajax.addCommentReply_URL
              data = {
                commentid: this.commentObj.item.commentid,
                replycontent: this.msgValue.trim()
              }
            }
          }
          var that = this
          if (this.msgValue.replace(/ /g, '') != '') {
            this.$customRequestAjax.post(url, data).then((res) => {
              if (res.data.code == 200) {
                this.commentParams.pageno = 1
                this.videoObj.commentnum = Number(this.videoObj.commentnum) + 1
                this.msgValue = ''
                this.onBlur()
                this.getLeaveData()
              }
            })
          } else {
            this.$toast('内容不能为空')
          }
        }
      })
    },
    // 视频点赞
    onPraise(obj = {}) {
      var url = this.$ajax.praiseVideo_URL,
        data = {
          type: 1,
          postsid: this.videoObj.id
        }
      if (obj.item) {
        data.ispraise = obj.item.ispraise == 0 ? 1 : 0
        data.commentid = obj.item.commentid
      } else {
        data.type = 0
        data.ispraise = this.videoObj.ispraise == 0 ? 1 : 0
      }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          if (obj.itemSon) {
            f(this.commentlist[obj.index].comment_reply[obj.indexSon])
          } else if (obj.item) {
            f(this.commentlist[obj.index])
          } else {
            f(this.videoObj)
          }
        }
      })
      function f(item) {
        if (item.ispraise == 0) {
          return (item.ispraise = 1), item.praisenum++
        } else {
          return (item.ispraise = 0), item.praisenum--
        }
      }
    },
    collectionFn: function() {
      var url = this.$ajax.collectVideo_URL,
        data = {
          itemid: this.videoObj.id,
          iscollection: this.videoObj.iscollection == 0 ? 1 : 0
        }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          if (this.videoObj.iscollection == 0) {
            this.videoObj.iscollection = 1
            this.videoObj.collectionnum++
          } else {
            this.videoObj.iscollection = 0
            this.videoObj.collectionnum--
          }
        }
      })
    },
    goHome() {
      this.$app.goIndex()
    },
    onSearch() {
      var arg = isApp()
      if (arg && arg.indexOf('xcx') < 0) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'beautySearch'
          })
        )
      } else {
        this.$app.argLink({
          path: '/bs'
        })
      }
    },
    onGoodsClick() {
      const goodsArr = this.videoObj.goods.split(',')
      if (goodsArr.length === 1) {
        this.goDetail(this.videoObj.goods)
      } else {
        this.$app.argLink({
          path: '/bspl',
          query: {
            itemids: this.videoObj.goods,
            beautitysaidid: this.videoObj.id
          }
        })
      }
    },
    goDetail(id) {
      var that = this
      let data = {
        itemid: id
      }
      that.$clickburiedPoint({
        url: 'ckysdatacenter/itemclick/save',
        data: data
      })
      var arg = isApp()
      if (arg == '') {
        that.$router.push({
          path: '/productdetail',
          query: {
            itemid: id,
            beautitysaidid: that.videoObj.id
          }
        })
      } else if (arg.indexOf('xcx') < 0) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'goItemDetail',
            itembaseid: id,
            beautitysaidid: that.videoObj.id
          })
        )
      } else {
        wx.miniProgram.navigateTo({
          url:
            '/pages/product/main?itemid=' +
            id +
            '&beautitysaidid=' +
            that.videoObj.id +
            '&exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      }
    },
    onShare() {
      var arg = isApp()
      if (arg && arg.indexOf('xcx') < 0) {
        var obj = {
          type: 'shareFriends',
          title: encodeURIComponent(this.videoObj.sharetitle),
          img: this.videoObj.shareimg,
          desc: encodeURIComponent(this.videoObj.sharedesc),
          link:
            basepath +
            '/Wxmall/WeChat/share' +
            wxAjaxData +
            '&type=beautitysaid&params=' +
            base.encode(
              JSON.stringify({
                beautitysaidid: this.videoObj.id
              })
            ) +
            arg
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(obj))
      } else {
        this.showshare = true
        this.$emit('showshare', this.showshare)
      }
    },
    hideShare() {
      this.showshare = false
      this.$emit('showshare', this.showshare)
    },
    initShare() {
      console.log('初始化分享')
      if (isWeixin()) {
        var arg = isApp()
        if (arg == '') {
          fenxiang({
            title: encodeURIComponent(this.videoObj.sharetitle),
            desc: encodeURIComponent(this.videoObj.sharedesc),
            imgx: this.videoObj.shareimg,
            type: 'beautitysaid',
            dataStr:
              'type=beautitysaid&params=' +
              base.encode(
                JSON.stringify({
                  beautitysaidid: this.videoObj.id
                })
              ),
            path: 'beautitysaiddetail'
          })
        } else if (arg.indexOf('xcx') >= 0) {
          var xcxObj = {
            type: 'beautitysaid',
            title: encodeURIComponent(this.videoObj.sharetitle),
            img: this.videoObj.shareimg,
            link: basepath + 'beautitysaiddetail?beautitysaidid=' + this.videoObj.id + arg
          }
          wx.miniProgram.postMessage({ data: xcxObj })
        }
      }
    },
    sendTimeupdate() {
      this.$emit('timeupdate')
    },
    onTimeUpdate() {
      if (!this.coverPrgress && this.$refs.videoPalyer) {
        this.value = (this.$refs.videoPalyer.currentTime / this.$refs.videoPalyer.duration) * 100
      }
      this.$emit('timeupdate')
    },
    goCommunity() {
      var arg = isApp()
      if (arg == '') {
        this.$store.commit('COMMUNITY_TAB', 3)
        this.$emit('headerClick', 3)
        if (this.$route.path == '/community') {
          this.$router.go()
        } else {
          this.$router.push({
            path: '/community'
          })
        }
      } else if (arg.indexOf('xcx') >= 0) {
        wx.miniProgram.reLaunch({
          url:
            '/pages/communityindex/main?communityTab=3&exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      } else if (arg.indexOf('xcx') < 0) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'goToBeautyTalk'
          })
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video-player-container {
  position: absolute;
  width: 100vw;
  top: 0px;
  left: 0px;
  z-index: 99;
}
.model-view {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0px;
  left: 0px;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  img {
    width: 100px;
    height: 100px;
    transform: rotate(210deg);
    position: relative;
  }
  .tips-msg {
    font-size: 0.2rem;
    font-weight: bold;
    margin-top: 30px;
    color: #ffffff;
  }
}
@keyframes moveUpDown {
  0% {
    top: 0;
  }
  25% {
    top: 20px;
  }
  50% {
    top: 0px;
  }
  75% {
    top: -20px;
  }
  100% {
    top: 0px;
  }
}
.video-player-wrap {
  position: relative;
  .video-player-box {
    width: 100vw;
    height: calc(100vh - constant(safe-area-inset-bottom)) !important;
    height: calc(100vh - env(safe-area-inset-bottom)) !important;
    background-color: #333333;
    .video-player {
      width: 100vw !important;
      height: calc(100vh - constant(safe-area-inset-bottom)) !important;
      height: calc(100vh - env(safe-area-inset-bottom)) !important;
      background-size: cover;
      background-position: center center;
      transition: height 0.5s;
      object-fit: cover;
    }
    &.small {
      height: 30vh !important;
      .video-player {
        height: 30vh !important;
      }
    }
  }
  .comment-box {
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 100vw;
    border-top: 1px solid #d8d8d8;
    padding: 0px 0.15rem;
    padding-top: 0.08rem;
    padding-bottom: calc(0.08rem + constant(safe-area-inset-bottom)) !important;
    padding-bottom: calc(0.08rem + env(safe-area-inset-bottom)) !important;
    background: #ffffff;
    z-index: 9999;
    display: flex;
    align-items: center;
    .comment-ipt {
      background: #f3f3f3;
      border-radius: 0.17rem;
      padding: 0.05rem 0.15rem;
      flex: 1;
      margin-right: 0.1rem;
    }
    .send-btn {
      font-size: 0.14rem;
      color: #666666;
      &.can-send {
        color: #fa1d43;
      }
    }
  }
  .comment-wrap {
    width: 100vw;
    background-color: #ffffff;
    height: 0px;
    transition: height 0.1s;
    border-radius: 0.08rem 0.08rem 0px 0px;
    position: relative;
    z-index: 999;
    padding: 0.13rem 0px;
    &.active {
      display: flex;
      flex-direction: column;
      height: 70vh;
    }
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 0.15rem;
      .close-btn {
        width: 0.2rem;
      }
      .center {
        font-weight: 600;
        font-size: 0.13rem;
        color: #333333;
      }
    }

    .comment_list {
      background: #ffffff;
      border-radius: 0.04rem;
      padding: 0px 0.15rem;
      padding-bottom: calc(0.6rem + constant(safe-area-inset-bottom)) !important;
      padding-bottom: calc(0.6rem + env(safe-area-inset-bottom)) !important;
      flex: 1;
      overflow-y: scroll;
      .empty-comment {
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        img {
          width: 0.82rem;
          margin-bottom: 0.18rem;
        }
        span {
          color: #333333;
          font-size: 0.13rem;
        }
      }
      .list {
        .pro_comment_item {
          /*padding: 0 .11rem;*/
          margin-top: 0.2rem;
          .pro_comment_item_box {
            display: flex;
            justify-content: space-between;
            &.comment_reply_item {
              margin-left: 0.36rem;
              position: relative;
              .comment_head_info {
                .img {
                  width: 0.2rem;
                  img {
                    width: 0.2rem;
                    height: 0.2rem;
                  }
                }
              }
            }
            .comment_head_info {
              position: relative;
              /*overflow: hidden;*/
              display: flex;
              .img {
                width: 0.3rem;
                float: left;
                img {
                  width: 0.3rem;
                  height: 0.3rem;
                  border-radius: 50%;
                }
              }
              .info {
                float: left;
                position: relative;
                .namebox {
                  display: flex;
                  align-items: center;
                  .name {
                    font-size: 0.14rem;
                    line-height: 0.2rem;
                    padding-left: 0.1rem;
                    color: #999999;
                    max-width: 2.4rem;
                    img {
                      /*width: 0.3rem;*/
                      height: 0.14rem;
                      margin-left: 0.02rem;
                    }
                    .sj {
                      width: 0;
                      height: 0;
                      border: 0.03rem solid transparent;
                      border-left-color: #999999;
                      margin-left: 0.04rem;
                    }
                  }
                  .time {
                    font-size: 0.08rem;
                    border: 0.005rem solid #fc0324;
                    border-radius: 0.02rem;
                    transform: scale(0.85);
                    color: #fc0324;
                    margin-left: 0.05rem;
                  }
                }
              }
            }
            .comment_content_info {
              padding-left: 0.1rem;
              display: flex;
              .comment_txt {
                font-size: 0.14rem;
                line-height: 0.2rem;
                color: #333333;
                word-break: break-word;
                &.delete {
                  text-decoration: line-through;
                }
                &.time {
                  font-size: 0.1rem;
                  margin-top: 0.08rem;
                  color: #999999;
                }
              }
              .reply_btn {
                margin-left: 0.05rem;
              }
            }
            .love {
              img {
                margin: 0 auto;
                width: 0.16rem;
                height: 0.16rem;
              }
              p {
                color: #999999;
                font-size: 0.1rem;
                text-align: center;
              }
            }
          }
          .more {
            margin-left: 0.65rem;
            margin-top: 0.1rem;
            font-size: 0.13rem;
            color: #338bf6;
          }
        }
      }
    }
  }
  .play-icon {
    position: absolute;
    left: calc(50% - 0.5rem);
    top: calc(50% - 0.7rem);
    z-index: 10;
  }
  .progress-bar {
    width: 100vw;
    position: absolute;
    bottom: calc(0.1rem + constant(safe-area-inset-bottom)) !important;
    bottom: calc(0.1rem + env(safe-area-inset-bottom)) !important;
    z-index: 100;
    display: flex;
    align-items: center;
    padding: 0px 0.12rem;
    font-size: 0.12rem;
    color: #ffffff;
    flex-direction: column;
    .time-info {
      margin-bottom: 10px;
      font-size: 16px;
    }
    .custom-button {
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        width: 4px;
        height: 4px;
        background-color: #ffffff;
      }
    }
  }
  .tool-bar {
    width: 0.48rem;
    position: absolute;
    right: 0.11rem;
    bottom: calc(1.1rem + constant(safe-area-inset-bottom)) !important;
    bottom: calc(1.1rem + env(safe-area-inset-bottom)) !important;
    z-index: 100;
    .avatur-box {
      width: 0.48rem;
      height: 0.48rem;
      position: relative;
      top: -0.1rem;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 1.5px solid #ffffff;
      }
      .floow-icon {
        position: absolute;
        width: 0.2rem;
        height: 0.2rem;
        bottom: -0.1rem;
        left: calc(50% - 0.1rem);
      }
    }
    .info-item {
      display: flex;
      flex-direction: column;
      margin-top: 0.1rem;
      align-items: center;
      color: #ffffff;
    }
  }
  .video-footer-box {
    width: 100vw;
    position: absolute;
    right: 0px;
    bottom: calc(0.44rem + constant(safe-area-inset-bottom)) !important;
    bottom: calc(0.44rem + env(safe-area-inset-bottom)) !important;
    padding: 0px 0.1rem;
    .about-goods {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.86rem;
      height: 0.31rem;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 0.04rem;
      img {
        width: 0.2rem;
      }
      span {
        padding-left: 0.06rem;
        font-weight: 400;
        font-size: 0.12rem;
        color: #ffffff;
      }
    }
    .video-footer {
      margin-top: 0.1rem;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .home-img {
        width: 0.48rem;
        height: 0.48rem;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .desc {
        width: 3.16rem;
        color: #ffffff;
        padding-right: 0.36rem;
        line-height: 0.22rem;
        .more-text {
          color: #338bf6;
        }
      }
    }
  }
}
.footer {
  height: constant(safe-area-inset-bottom);
  height: env(safe-area-inset-bottom);
  background-color: #333333;
  z-index: 9999;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/community-beautitysaid/components/VideoPlayer.vue